"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _Topbar = _interopRequireDefault(require("../Topbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      paddingTop: 64,
      display: 'flex',
      minHeight: '100vh'
    },
    content: {
      flexGrow: 1
    }
  };
});

var Minimal = function Minimal(_ref) {
  var topBarProps = _ref.topBarProps,
      mainClassname = _ref.mainClassname,
      className = _ref.className,
      children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_Topbar.default, topBarProps), /*#__PURE__*/_react.default.createElement("main", {
    className: (0, _clsx.default)(classes.content, mainClassname)
  }, children));
};

Minimal.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string
};
var _default = Minimal;
exports.default = _default;